import { useEffect, useState } from 'react';

import AccordionCustom from '../../../components/AccordionCustom';
import cn from '../../../lib/classNames';

import { WATCHDOG_COPY } from './watchdogCopy';

import styles from './Watchdog.module.scss';

type ChipTone = 'active' | 'idle' | 'ended';

export function StatusChip({ label, tone }: { label: string; tone: ChipTone }) {
	return (
		<span className={cn(styles.chip, styles[`chip--${tone}`])}>
			<i className={styles['chip-dot']} />
			{label}
		</span>
	);
}

export function Toast({ message, onDismiss }: { message: string; onDismiss: () => void }) {
	useEffect(() => {
		const timer = window.setTimeout(onDismiss, 6000);
		return () => window.clearTimeout(timer);
	}, [onDismiss]);

	return (
		<div className={styles.toast} role="status" aria-live="polite">
			<span className="material-icons">check_circle</span>
			{message}
		</div>
	);
}

/** Collapsible "About Watchdog findings" block (§8). */
export function WatchdogDisclaimer() {
	const [expanded, setExpanded] = useState('');

	return (
		<div className={styles.disclaimer}>
			<AccordionCustom
				panel="watchdog-disclaimer"
				panelContent="watchdog-disclaimer-content"
				headerText={WATCHDOG_COPY.disclaimerHeader}
				expanded={expanded}
				setExpanded={setExpanded}
			>
				<p className={styles['disclaimer-body']}>{WATCHDOG_COPY.disclaimerBody}</p>
			</AccordionCustom>
			<p className={styles['one-liner']}>{WATCHDOG_COPY.disclaimerOneLiner}</p>
		</div>
	);
}
